import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6" data-testid="not-found">
      <div className="text-center max-w-md">
        <div className="font-display text-8xl text-[#C9A84C]">404</div>
        <h1 className="font-display text-3xl md:text-4xl text-[#1E2761] tracking-tight mt-4">
          This Page Hasn't Been Written Yet.
        </h1>
        <p className="text-[#334155]/80 mt-4 leading-relaxed">
          The link you followed might be outdated, or the page may have moved.
          Let's get you back on track.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-3 bg-[#1E2761] text-white px-7 py-3.5 font-medium tracking-wide hover:bg-[#161d4b] transition-colors"
          data-testid="not-found-home-link"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
